import { render, staticRenderFns } from "./c-Sub-materi.vue?vue&type=template&id=7c3b70b4&scoped=true&"
import script from "./c-Sub-materi.vue?vue&type=script&lang=js&"
export * from "./c-Sub-materi.vue?vue&type=script&lang=js&"
import style0 from "./c-Sub-materi.vue?vue&type=style&index=0&id=7c3b70b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3b70b4",
  null
  
)

export default component.exports